import type { QueueCaller } from '../types'

export function shouldShowHoldAlert(
  caller: QueueCaller,
  holdAlertThreshold: number,
): boolean {
  const isWaiting = caller.state === 'Waiting' || caller.state === 'Trying'
  return isWaiting && caller.score >= holdAlertThreshold
}

export function setupHoldAlertTimer(
  caller: QueueCaller,
  holdAlertThreshold: number,
  onAlert: () => void,
): () => void {
  const timeUntilAlert = (holdAlertThreshold - caller.score) * 1000

  if (timeUntilAlert <= 0) {
    onAlert()
    return () => {}
  }

  const timerId = setTimeout(onAlert, timeUntilAlert)
  return () => clearTimeout(timerId)
}
